import { CareerManagerFollowedCollaborators } from "../../../types/api/careerManagers.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CareerManagersFollowedService = {
  async list(
    careerManagerId: string,
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<CareerManagerFollowedCollaborators> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response = await httpClient.get<CareerManagerFollowedCollaborators>(
      `v1/career-managers/${careerManagerId}/follow?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
};

export default CareerManagersFollowedService;
